// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"6fca5da5","563":"a582ab6a","747":"6cf38ac4"}[chunkId] + ".chunk.js";
};